import { Fragment, ReactElement } from 'react';
import { useIntl } from 'react-intl';

import Link from 'next-translate-routes/link';
import { ButtonLink, Button } from '@components/atoms/Button';
import { linkResolver } from '@prismic/prismic-config';

import { commonMessages } from '../../../../intl';

import { IProps } from './types';
import * as S from './styles';

export function SliceIconCta({ slice: { fields } }: IProps): ReactElement {
  const intl = useIntl();
  return (
    <S.Wrapper className="slice-item slice-icon-cta">
      {Boolean(fields.length) &&
        fields.map((z, i) => {
          const { title, link, img } = z;
          return (
            <Fragment key={`slice-icon-cta__item_${i}`}>
              <S.Item className="slice-icon-cta__item">
                <img src={(img as any)?.url} alt="Img" />
                <S.ItemTitle>{title}</S.ItemTitle>
                {link?.__typename === '_FileLink' && (
                  <a href={(link as any)?.url} download={(link as any)?.name}>
                    <Button fullWidth>
                      {intl.formatMessage(commonMessages.download)}
                    </Button>
                  </a>
                )}
                {!(link?.__typename === '_FileLink') && (
                  <Link href={linkResolver(link)} passHref>
                    <ButtonLink fullWidth>
                      {intl.formatMessage(commonMessages.showMore)}
                    </ButtonLink>
                  </Link>
                )}
              </S.Item>
              {i + 1 < fields.length && (
                <S.Separator className="slice-icon-cta__separator" />
              )}
            </Fragment>
          );
        })}
    </S.Wrapper>
  );
}

SliceIconCta.componentName = 'iconcta';
